export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEKSEtzY3MtQjUtSGEIoV0BgQICAYEGAgGBCgIBgQ4CAYESAgGBFgIBgRoCAYEeYQShSwDqTg4A6y8BAOsxgQYA6k9hAcbkAe4R", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/HKscs-B5-V.bcmap
// module id = 665
// module chunks = 502